import { type GeocodingAction } from './geocoding.action';
import {
  GEOCODING_PAUSE_ERROR,
  GEOCODING_PAUSE_SUCCESS,
  GEOCODING_RESUME_ERROR,
  GEOCODING_RESUME_SUCCESS,
  GEOCODING_SET_IS_PAUSE_RESUME_LOADING,
  GEOCODING_SET_PROGRESS,
  GEOCODING_START_TRACKING,
} from './geocoding.actionTypes';
import {
  type GeocodingState,
  pauseRequest,
  resumeRequest,
  setRequestLoading,
  unsetRequestLoading,
  updateSpreadsheetProgress,
} from './geocoding.state';

const initialState: GeocodingState = {
  perSpreadsheetGeocodingRequest: {},
};

export const geocodingReducer = (state = initialState, action: GeocodingAction): GeocodingState => {
  switch (action.type) {
    case GEOCODING_START_TRACKING: {
      return updateSpreadsheetProgress(
        state, {
          [action.payload.item.realSpreadsheetId]: {
            realSpreadsheetId: action.payload.item.realSpreadsheetId,
            progress: action.payload.item.progress,
            triggeredByUserId: action.payload.item.triggeredByUserId,
            isPaused: action.payload.item.isPaused,
          },
        }
      );
    }

    case GEOCODING_SET_PROGRESS: {
      return updateSpreadsheetProgress(state, action.payload.updates);
    }

    case GEOCODING_PAUSE_SUCCESS: {
      return pauseRequest(unsetRequestLoading(state, action.payload.realSpreadsheetId), action.payload.realSpreadsheetId);
    }

    case GEOCODING_RESUME_SUCCESS: {
      return resumeRequest(unsetRequestLoading(state, action.payload.realSpreadsheetId), action.payload.realSpreadsheetId);
    }

    case GEOCODING_SET_IS_PAUSE_RESUME_LOADING: {
      return setRequestLoading(state, action.payload.realSpreadsheetId);
    }

    case GEOCODING_PAUSE_ERROR:
    case GEOCODING_RESUME_ERROR: {
      return unsetRequestLoading(state, action.payload.realSpreadsheetId);
    }

    default: {
      return state;
    }
  }
};
